/**
 * appPlatform — uygulama platform sınıfları SSoT (frontend).
 * ==========================================================
 * Backend karşılığı: backend/src/application/services/appPlatform.js (normalizePlatform).
 * Drift-guard: backend/tests/app-platform-smoke.js — iki APP_PLATFORMS listesi eşit olmalı.
 *
 * Kullanım: getAppPlatform() app açılışında platformu tespit eder; _app.js oturum
 * başına 1 kez POST /api/kullanim/oturum ile { platform } gönderir (mobil/app kullanım
 * metrikleri). Saf çekirdek classifyPlatform ayrı → node smoke ile test edilir.
 */

export const APP_PLATFORMS = ['twa', 'pwa', 'ios-pwa', 'web'] as const;
export type AppPlatform = (typeof APP_PLATFORMS)[number];

export interface PlatformSignals {
  /** document.referrer */
  referrer: string;
  /** window.matchMedia('(display-mode: standalone)').matches */
  displayModeStandalone: boolean;
  /** (navigator as any).standalone === true (iOS Safari ana ekran PWA) */
  iosStandalone: boolean;
}

/**
 * Saf sınıflama — tarayıcı API'si OKUMAZ, yalnızca verilen sinyallerden karar verir
 * (test edilebilir). Öncelik: TWA (android-app referrer) → iOS PWA → PWA (standalone) → web.
 */
export function classifyPlatform(s: PlatformSignals): AppPlatform {
  if (s.referrer && s.referrer.startsWith('android-app://com.riskmatik')) return 'twa';
  if (s.iosStandalone) return 'ios-pwa';
  if (s.displayModeStandalone) return 'pwa';
  return 'web';
}

/** Tarayıcıdan sinyalleri toplayıp classifyPlatform'a delege eder (SSR-güvenli). */
export function getAppPlatform(): AppPlatform {
  if (typeof window === 'undefined') return 'web';
  let displayModeStandalone = false;
  try {
    displayModeStandalone =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(display-mode: standalone)').matches;
  } catch {
    displayModeStandalone = false;
  }
  const nav = window.navigator as unknown as { standalone?: boolean };
  return classifyPlatform({
    referrer: (typeof document !== 'undefined' && document.referrer) || '',
    displayModeStandalone,
    iosStandalone: nav?.standalone === true,
  });
}
